// @ts-check

/**
 * @typedef {import('./buildPadPrescriptionEvent').PadPrescription} PadPrescription
 * @typedef {import('./buildPadPrescriptionEvent').DtEvent} DtEvent
 * @typedef {import('./transformPadPrescriptionsToPrescriptionLoadSchedule').PadVisit} PadVisit
 * @typedef {import('../calendarVisitSchedule.schema').CalendarVisitSchedule} CalendarVisitSchedule
 */
import {
  buildCalendarVisitSchedule,
  createCalendarVisitSchedule
} from '../calendarVisitSchedule.schema';
import { shouldIncludeAsVisitPrescriptionScheduleCooperative } from './shouldIncludeAsVisitPrescriptionScheduleCooperative';
import { transformPadPrescriptionsToPrescriptionLoadSchedule } from './transformPadPrescriptionsToPrescriptionLoadSchedule';

/**
 * Transforms a single padVisit into a CalendarVisitSchedule structure for prescription cooperative visits.
 * Pure function with no side effects.
 *
 * @param {PadVisit} padVisit - The PAD visit object (may contain a padPrescriptions property of type PadPrescription[])
 * @returns {CalendarVisitSchedule | []} The transformed CalendarVisitSchedule object in cooperative prescription mode
 */
export const transformPadVisitToVisitPrescriptionScheduleCooperative = padVisit => {
  if (!shouldIncludeAsVisitPrescriptionScheduleCooperative(padVisit)) return [];

  const { padPrescriptions = [] } = padVisit;
  const prescriptionLoadSchedule = transformPadPrescriptionsToPrescriptionLoadSchedule(
    padPrescriptions,
    padVisit
  );

  return createCalendarVisitSchedule({
    ...buildCalendarVisitSchedule({ ...padVisit }),
    prescriptionLoadSchedule
  });
};
